import React from 'react';
import { observer } from 'mobx-react-lite';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { TimeCellWrapper } from './TimeCellStyles';

interface IProps {
  selectedValue: any;
  onSelectionChanged: (newVal: any) => void;
  isAddedManually: boolean;
}

export const TimeCell: React.FC<IProps> = observer(({ selectedValue, onSelectionChanged, isAddedManually }) => {
  return (
    <TimeCellWrapper>
      <DatePicker
        selected={selectedValue}
        onChange={(date) => onSelectionChanged(date)}
        showTimeSelect
        timeFormat='h:mm:ss aa'
        timeCaption='time'
        dateFormat='MM/dd, yyyy h:mm:ss aa'
        maxDate={new Date()}
        disabled={!isAddedManually}
      />
    </TimeCellWrapper>
  );
});
